import React, { useContext } from "react"
import { BackButton, ButtonsDiv, Container, YesDeleteButton, HeaderDiv, MainText, TipText } from "./style"
import ModalContext from "../../contexts/ModalContext"
import trash from "../../assets/assesses/red-trash.svg"
import axios from "axios"
import UserContext from "../../contexts/UserContext"
import { useProfileContext } from "../../contexts/AccessesContext"

export const DeleteProfile: React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const { token } = useContext(UserContext)
  const { fetchProfiles, deletedProfile } = useProfileContext()

  const deleteProfile = async() => {
    try {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/profile/${deletedProfile}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      fetchProfiles()
    } catch (error) {
      console.error('Erro ao deletar perfil', error)
    }
    setModalActive(false)
  }
  
  return(
    <Container>
      <HeaderDiv>
        <img src={trash} alt='trash icon' />
      </HeaderDiv>
      <MainText>
        Tem certeza que deseja excluir este perfil?
      </MainText>
      <TipText>
        Essa ação não poderá ser desfeita.
      </TipText>

      <ButtonsDiv>
        <BackButton onClick={() => setModalActive(false)}>Não, voltar</BackButton>
        <YesDeleteButton onClick={() => deleteProfile()}>Sim, excluir</YesDeleteButton>
      </ButtonsDiv>
    </Container>
  )
}